import { clsx } from 'clsx';
import type { PropsWithChildren, ReactNode } from 'react';

import styles from './ContentActionsLayout.css';

interface IContentActionsLayoutProps {
  hovered: boolean;
}

export const ContentActionsLayout = ({
  children,
  hovered,
}: PropsWithChildren<IContentActionsLayoutProps>): ReactNode => {
  return <div className={clsx(styles['actions-layout'], hovered && styles['actions-layout_hovered'])}>{children}</div>;
};
